<template>
  <v-container fluid class="pa-0">
    <v-dialog v-model="dialogo" width="auto">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('actualizar_constantes') }}</v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-file-input v-model="inputZip" :placeholder="$t('selecciona_zip')"/>
              </v-col>
            </v-row>

            <v-divider/>
            <v-row class="pt-2" no-gutters>
              <v-col cols="8">
                <v-btn :loading="actualizando" @click="actualizarZip" :disabled="!inputZip" color="primary" depressed>
                  {{ $t('actualizar') | capitalize }}
                </v-btn>
              </v-col>
              <v-col cols="4" class="text-right">
                <v-btn @click="cerrarDialogoZip" color="error" depressed>
                  {{ $t('descartar') | capitalize }}
                </v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar color="primary white--text" elevation="0">
          <v-toolbar-title class="font-weight-bold">
            {{ $tc('listado_constantes', 2) | capitalize }}
          </v-toolbar-title>
          <v-spacer/>
          <v-text-field v-model="busqueda" hide-details solo :placeholder="$t('escribe_buscar')" color="secondary"
                        prepend-inner-icon="mdi-magnify" :loading="escribiendoEnBusqueda > 0"/>

          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn icon color="white" @click="subirConstantes()" v-on="on">
                <v-icon>mdi-file-upload</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('subir_constantes') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn icon color="white" @click="descargarConstantes()" v-on="on">
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('descargar_constantes') }}</span>
          </v-tooltip>

          <v-btn icon color="white" :loading="cargando" @click="obtenerConstantes()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list>
          <div v-if="cargando">
            <v-skeleton-loader v-for="i in porPagina" :key="i" ref="skeleton" type="list-item-three-line"
                               class="mx-auto"/>
          </div>
          <div v-if="!cargando">
            <v-list-item v-for="(constante,index) in listado" :key="index" three-line class="constante-item">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-bold">
                  {{ constante.codigo }}
                </v-list-item-title>

                <v-list-item-subtitle>
                  {{ constante.descripcion }} ({{ constante.tipoObjeto }})
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-btn icon color="primary" @click="abrir(constante)">
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </div>
          <div v-if="!cargando && listado.length === 0">
            <v-list-item class="constante-item">
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-bold">
                  {{ $t('sin_constantes') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>

        <div class="text-center mb-2" v-show="paginas > 0">
          <v-pagination circle v-model="pagina" :length="paginas" :disabled="cargando" :total-visible="10"/>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import DescargasHelper from "@/comunes/helpers/DescargasHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";

export default {
  name: 'ConstantesPagina',
  components: {},
  data: () => ({
    listado: [],
    cargando: false,
    pagina: 1,
    porPagina: 10,
    paginas: 0,
    busqueda: "",
    escribiendoEnBusqueda: 0,
    acabadoCreated: false,
    dialogo: false,
    inputZip: null,
    actualizando: false
  }),
  created() {
    const rQuery = this.$route.query;

    if (rQuery.pagina) this.pagina = parseInt(rQuery.pagina);
    if (rQuery.porPagina) this.porPagina = parseInt(rQuery.porPagina);
    if (rQuery.busqueda) this.busqueda = rQuery.busqueda;
    setTimeout(() => this.acabadoCreated = true, 200);
  },
  mounted: function () {
    this.obtenerConstantes();
  },
  watch: {
    pagina: function () {
      if (!this.acabadoCreated) return;
      this.obtenerConstantes();
      this.actualizaQueryPagina({pagina: this.pagina + ""});
    },
    porPagina: function () {
      if (!this.acabadoCreated) return;
      this.obtenerConstantes();
      this.actualizaQueryPagina({porPagina: this.porPagina + ""});
    },
    busqueda: function () {
      if (!this.acabadoCreated) return;
      this.escribiendoEnBusqueda++;
      setTimeout(async () => {
        this.escribiendoEnBusqueda--;
        if (this.escribiendoEnBusqueda === 0) {
          await this.actualizaQueryPagina({busqueda: this.busqueda + ""});
          if (this.pagina === 1) this.obtenerConstantes()
          else this.pagina = 1;
        }
      }, 600);
    }
  },
  methods: {
    obtenerConstantes() {
      this.cargando = true;
      let params = {
        pagina: this.pagina - 1,
        porPagina: this.porPagina,
        busqueda: this.busqueda
      };
      HttpHelper.get(`admin/constantes/listado`, params)
          .then((constantes) => {
            if (constantes.content.length < 1) {
              this.pagina = 1;
              this.listado = [];
              this.paginas = 0;
              return;
            }

            this.listado = constantes.content;
            this.paginas = constantes.totalPages;
          })
          .catch(() => {
            this.listado = [];
            this.pagina = 1;
            this.paginas = 0;
          })
          .finally(() => this.cargando = false);
    },
    abrir(constante) {
      VueRouteHelper.goTo(`admin-constantes-detalles/${constante.id}`, this.$router);
    },
    async actualizaQueryPagina(cambios) {
      const queryNueva = JSON.parse(JSON.stringify(this.$route.query));

      Object.keys(cambios).forEach((keyOb) => queryNueva[keyOb] = cambios[keyOb]);

      if (JSON.stringify(this.$route.query) !== JSON.stringify(queryNueva))
        await this.$router.replace({query: queryNueva});
    },
    descargarConstantes() {
      HttpHelper.get(`admin/constantes/descargar-todos`)
          .then((resp) => DescargasHelper.descargarBase64(`${resp.nombre}`, resp.contenido, resp.mime))
          .catch((e) => {
            console.error(e);
            this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('constantes_error_descarga'), color: "error"});
          })
    },
    subirConstantes() {
      this.dialogo = true;
    },
    cerrarDialogoZip() {
      this.dialogo = false;
      this.inputZip = null;
    },
    actualizarZip() {
      this.actualizando = true;
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        HttpHelper.post(`admin/constantes/actualizar-todos`, {zip: btoa(e.target.result)})
            .then(() => {
              this.cerrarDialogoZip();
              this.obtenerConstantes();
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('constantes_actualizadas'), color: "success"});
            })
            .catch((e) => {
              console.error(e);
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('constantes_error'), color: "error"});
            })
            .finally(() => this.actualizando = false);
      };
      fileReader.readAsBinaryString(this.inputZip);
    }
  }
};
</script>

<style lang="scss" scoped>
.constante-item {
  min-height: 88px;
  max-height: 88px;
}
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "cargando_constantes": "Cargando constantes",
    "listado_constantes": "Listado de constantes",
    "sin_constantes": "No se han obtenido constantes",
    "actualizar_constantes": "Actualizar todas las constantes",
    "selecciona_zip": "Selecciona el comprimido Zip",
    "subir_constantes": "Subir todas las constantes en un comprimido",
    "descargar_constantes": "Descargar todas las constantes en un comprimido",
    "constantes_actualizadas": "Se han actualizado las constantes",
    "constantes_error": "Ha ocurrido un error al actualizar las constantes",
    "constantes_error_descarga": "Ha ocurrido un error al descargar las constantes"
  }
}
</i18n>
<!-- @formatter:on -->